import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastItem {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  timeout?: number;
}

@Injectable({ providedIn: 'root' })
export class NicaToastService {

  private _toasts = new BehaviorSubject<ToastItem[]>([]);
  public toasts$ = this._toasts.asObservable();

  addToast(toast: Pick<ToastItem, 'message' | 'timeout' | 'type'>) {
    const id = Math.random().toString(36).substring(2, 9);
    const item: ToastItem = { id, ...toast };
    this._toasts.next([...this._toasts.value, item]);
    console.log(toast)
    if (item.timeout && item.timeout > 0) {
      setTimeout(() => this.removeToast(id), item.timeout);
    } else {
      setTimeout(() => this.removeToast(id), 20000);
    }
  }

  removeToast(id: string) {
    this._toasts.next(this._toasts.value.filter(t => t.id !== id));
  }
}
